import { usePresentationVisibility } from '@/hooks/usePresentationVisibility'
import { useRecordingStore } from '@/store/recording.store'

export function RecordingElapsed() {
  const visible = usePresentationVisibility()
  const durationMs = useRecordingStore(state =>
    visible ? state.durationMs : 0,
  )
  const seconds = Math.floor(durationMs / 1000)
  const h = Math.floor(seconds / 3600)
  const m = Math.floor((seconds % 3600) / 60)
  const s = seconds % 60
  const pad = (n: number) => String(n).padStart(2, '0')
  return <>{h > 0 ? `${h}:${pad(m)}:${pad(s)}` : `${pad(m)}:${pad(s)}`}</>
}
